<template>
  <div aria-hidden="true" class="onboarding-modal modal fade animated show" id="onboardingWideFormModal" role="dialog" tabindex="-1" style="display: block;">
    <div class="modal-dialog modal-lg modal-centered" role="document">

        <div class="modal-content">
            <div class="modal-header faded smaller">
                <div class="modal-title">
                  <span>Added By:</span><img alt="" class="avatar" :src="'http://52.66.102.131/'+getUser.avatar">
                  <span>SKU: </span><strong>{{product.identifier}}</strong>
                </div>
                <button aria-label="Close" class="close" @click="closeModal"type="button"><span aria-hidden="true"> ×</span></button>
            </div>
                <Error v-if="state == 'error'" />
                <Loader v-if="state == 'loading'" :type="'modal'"/>
                <div class="modal-body" v-if="state == 'ready'">
                <form>
                    <div class="form-group"><label for="">Comment</label><textarea class="form-control" name="" rows="3" v-model="commentBody">The similar diesel only tell deference and likewise, thought, nonetheless, for ahead school. The were organization.</textarea></div>
                </form>
            </div>
            <div class="modal-footer buttons-on-left">
              <button class="btn btn-teal" @click="handleCommentSubmit()" type="button"> Add Comment</button>
              <button class="btn btn-link" @click="closeModal()" type="button"> Cancel</button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import Error from '@/components/common/Error'
export default {
  props: ['product', 'state'],
  data: function () {
    return {
      commentBody: ''
    }
  },
  components: { Loader, Error },
  methods: {
    handleCommentSubmit: function () {
      var self = this
      const url = '/reportdesk/product/comment'
      let data = {
        'ounass_id': self.product.ounass_id,
        'body': self.commentBody
      }
      this.$http.post(url, data,
        {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', { text: 'Comment added', show: true })
          self.product.comments = 1
          self.closeModal()
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', { text: error.response.data.message, show: true })
        })
    },
    closeModal: function () {
      this.$emit('modalInterface')
    }
  },
  computed: {
    getUser () {
      return this.$store.getters.authUser
    }
  }
}
</script>
